import React from 'react'
import PropTypes from 'prop-types'
import { Tag } from 'antd'
import * as Icons from '@ant-design/icons'
import { Queries } from 'admin/lib/Api'

export const AccountTag = ({ accountId }) => {
  const account = Queries.useAccount(accountId)

  const isLoaded = !account.isFetching && !account.isError && account.data
  const isError = !account.isFetching && account.isError

  return (
    <Tag color={isError ? 'red' : 'default'}>
      {account.isFetching && <Icons.LoadingOutlined />}

      {isLoaded && account.data.name}

      {isError &&
        JSON.stringify(account.error?.response?.status ?? account.error)}
    </Tag>
  )
}

AccountTag.propTypes = {
  accountId: PropTypes.string
}
